import { render, staticRenderFns } from "./TwoFactorProfileSetup.vue?vue&type=template&id=24999e37&scoped=true"
import script from "./TwoFactorProfileSetup.vue?vue&type=script&lang=js"
export * from "./TwoFactorProfileSetup.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorProfileSetup.vue?vue&type=style&index=0&id=24999e37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24999e37",
  null
  
)

export default component.exports